module.exports = __webpack_public_path__ + "img/RevisionCredit.ffaed345.png";